const smoothEase = [0.22, 1, 0.36, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.58, ease: smoothEase },
  },
};

export const stagger = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.04,
    },
  },
};

export const slowFadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.72, ease: smoothEase },
  },
};

export const slowStagger = {
  hidden: {},
  show: {
    transition: {
      delayChildren: 0.06,
      staggerChildren: 0.12,
    },
  },
};

/** No motion: use when `useReducedMotion()` is true */
export const slowFadeUpStatic = {
  hidden: { opacity: 1, y: 0 },
  show: { opacity: 1, y: 0, transition: { duration: 0 } },
};

export const slowStaggerStatic = {
  hidden: {},
  show: {
    transition: {
      delayChildren: 0,
      staggerChildren: 0,
    },
  },
};
